
import { HeroBlock } from './HeroBlock';
import { RichTextBlock } from './RichTextBlock';
import { ImageWithTextBlock } from './ImageWithTextBlock';
import { CtaButtonBlock } from './CtaButtonBlock';
import { FormBlock } from './FormBlock';
import { TextWithDualImagesBlock } from './TextWithDualImagesBlock';

export interface ContentBlock {
  id: string;
  type: string;
  content: any;
  isHidden: boolean;
}

interface BlockRendererProps {
  block: ContentBlock;
}

export const BlockRenderer = ({ block }: BlockRendererProps) => {
  if (block.isHidden) return null;

  switch (block.type) {
    case 'hero':
      return <HeroBlock content={block.content} />;
    case 'richText':
      return <RichTextBlock content={block.content} />;
    case 'imageWithText':
      return <ImageWithTextBlock content={block.content} />;
    case 'ctaButton':
      return <CtaButtonBlock content={block.content} />;
    case 'formBlock':
      return <FormBlock content={block.content} />;
    case 'textWithDualImages':
      return <TextWithDualImagesBlock content={block.content} />;
    default:
      return null;
  }
};
